import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useUser } from '../components/UserContext';

function Login() {
	const { user, login } = useUser();
	const [formData, setFormData] = useState({
		firstName: '',
		lastName: '',
		email: '',
		phone: '',
		password: '',
	});
	const [errors, setErrors] = useState({});

	const handleChange = (e) => {
		setFormData({ ...formData, [e.target.name]: e.target.value });
		setErrors({ ...errors, [e.target.name]: '' });
	};

	const validate = () => {
		const newErrors = {};
		if (!formData.firstName.trim()) newErrors.firstName = 'First Name is required';
		if (!formData.lastName.trim()) newErrors.lastName = 'Last Name is required';
		if (!formData.email.trim()) {
			newErrors.email = 'Email is required';
		} else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
			newErrors.email = 'Invalid email format';
		}
		if (!formData.phone.trim()) {
			newErrors.phone = 'Phone number is required';
		} else if (!/^\d{10}$/.test(formData.phone)) {
			newErrors.phone = 'Phone number must be 10 digits';
		}
		if (!formData.password.trim()) {
			newErrors.password = 'Password is required';
		} else if (formData.password.length < 6) {
			newErrors.password = 'Password must be at least 6 characters';
		}
		return newErrors;
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		const validationErrors = validate();
		if (Object.keys(validationErrors).length > 0) {
			setErrors(validationErrors);
			return;
		}

		login(formData); // Use the login function from the context
	};

	const handleReset = () => {
		setFormData({
			firstName: '',
			lastName: '',
			email: '',
			phone: '',
			password: '',
		});
	};

	if (user) {
		return <Navigate to="/privacy" />;
	}

	return (
		<div className="bg-gradient-to-r from-blue-200 to-purple-500 min-h-screen flex items-center justify-center px-4">
			<div className="bg-white p-10 rounded-2xl shadow-md w-full max-w-4xl">
				<h2 className="text-2xl font-bold mb-6 text-left text-gray-800">Login</h2>
				<form
					onSubmit={handleSubmit}
					className="space-y-6"
				>
					<div className="grid grid-cols-2 gap-6">
						<div>
							<label
								htmlFor="firstName"
								className="block text-sm font-medium text-gray-700"
							>
								First Name
							</label>
							<input
								type="text"
								id="firstName"
								name="firstName"
								value={formData.firstName}
								onChange={handleChange}
								className="mt-2 block w-full rounded-md border border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 px-4 py-3"
								placeholder="Enter your first name"
							/>
							{errors.firstName && <p className="text-red-500 text-sm mt-1">{errors.firstName}</p>}
						</div>
						<div>
							<label
								htmlFor="lastName"
								className="block text-sm font-medium text-gray-700"
							>
								Last Name
							</label>
							<input
								type="text"
								id="lastName"
								name="lastName"
								value={formData.lastName}
								onChange={handleChange}
								className="mt-2 block w-full rounded-md border border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 px-4 py-3"
								placeholder="Enter your last name"
							/>
							{errors.lastName && <p className="text-red-500 text-sm mt-1">{errors.lastName}</p>}
						</div>
					</div>
					<div className="grid grid-cols-2 gap-6">
						<div>
							<label
								htmlFor="email"
								className="block text-sm font-medium text-gray-700"
							>
								Email
							</label>
							<input
								type="email"
								id="email"
								name="email"
								value={formData.email}
								onChange={handleChange}
								className="mt-2 block w-full rounded-md border border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 px-4 py-3"
								placeholder="Enter your email"
							/>
							{errors.email && <p className="text-red-500 text-sm mt-1">{errors.email}</p>}
						</div>
						<div>
							<label
								htmlFor="phone"
								className="block text-sm font-medium text-gray-700"
							>
								Phone
							</label>
							<input
								type="tel"
								id="phone"
								name="phone"
								value={formData.phone}
								onChange={handleChange}
								className="mt-2 block w-full rounded-md border border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 px-4 py-3"
								placeholder="Enter your phone number"
							/>
							{errors.phone && <p className="text-red-500 text-sm mt-1">{errors.phone}</p>}
						</div>
					</div>

					<div>
						<label
							htmlFor="password"
							className="block text-sm font-medium text-gray-700"
						>
							Password
						</label>
						<input
							type="password"
							id="password"
							name="password"
							value={formData.password}
							onChange={handleChange}
							className="mt-2 block w-full rounded-md border border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 px-4 py-3"
							placeholder="Enter your password"
						/>
						{errors.password && <p className="text-red-500 text-sm mt-1">{errors.password}</p>}
					</div>

					<div className="flex space-x-4 justify-center">
						<button
							type="submit"
							className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-3 px-6 rounded-md shadow-md transition"
						>
							LOGIN
						</button>
						<button
							type="button"
							className="bg-red-500 hover:bg-danger-600 text-white font-bold py-3 px-6 rounded-md shadow-md transition"
							onClick={handleReset}
						>
							Reset
						</button>
					</div>
				</form>
			</div>
		</div>
	);
}

export default Login;
